var product_swatch_carousel_frame = new Swiper(
  ".product-swatch-carousel-frame",
  {
    loop: true,
    spaceBetween: 10,
    slidesPerView: 2.3,
    centeredSlides: true,
    roundLengths: true,
    slideToClickedSlide: true,
    speed: 500,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    a11y: {
      enabled: false,
    },
    breakpoints: {
      320: {},
      480: {
        slidesPerView: 2.2,
      },
      768: {},
      1024: {},
    },
    on: {
      // LazyLoad swiper images after swiper initialization
      afterInit: (swiper) => {
        new LazyLoad({
          container: swiper.el,
          cancel_on_exit: false,
        });
      },
    },
    on: {
      setTransition: function () {},
    },
  }
);

$(".product-swatch-carousel-frame .swiper-slide").each(function (
  index,
  element
) {
  if ($(this).find("input").attr("checked") == "checked") {
    // console.log (index);
    if (index > 2 && index < 6) {
      product_swatch_carousel_frame.slideTo(index);
    }
  }
});

let isOnSpecial = false;
let specialChanging = false;
let chosenSpecial = false;

product_swatch_carousel_frame.on("slideChangeTransitionEnd", function () {
  console.log("hi");

  $(".product-swatch-carousel-frame .swiper-slide-active label").click();
  // If there is a special edition
  if (window.specialEditionFrame != "") {
    // console.log("Framename");
    let frameName = jQuery(
      ".product-swatch-carousel-frame .swiper-slide-active label"
    ).data("frame");
    console.log(frameName + " " + window.specialEditionFrame);
    // console.log(frameName);
    // If we are selected on special edition
    if (window.specialEditionFrame == frameName) {
      product_swatch_carousel_lens.slideTo(4);
      specialChanging = true;
      chosenSpecial = true;
    } else {
      if (chosenSpecial == true) {
        isOnSpecial = false;
        if ((product_swatch_carousel_lens.realIndex = 4)) {
          product_swatch_carousel_lens.slideTo(0);
        }
        chosenSpecial = false;
        // potentially wrong
        specialChanging = false;
      }
    }

    if (product_swatch_carousel_frame.realIndex == 4) {
      // console.log("here");
      jQuery(".product-swatch-carousel-lens .swiper-pagination").hide();
      jQuery(".product-swatch-carousel-lens  .swiper-button-next").each(
        function () {
          this.style.setProperty("display", "none", "important");
        }
      );
      jQuery(".product-swatch-carousel-lens  .swiper-button-prev").each(
        function () {
          this.style.setProperty("display", "none", "important");
        }
      );
      jQuery(".product-swatch-carousel-lens  .swiper-button-prev").each(
        function () {
          this.style.setProperty("display", "none", "important");
        }
      );
      jQuery(
        ".product-swatch-carousel-lens .swiper-wrapper .swiper-slide:first-child .product-swatch-item:nth-child(2), .product-swatch-carousel-lens .swiper-wrapper .swiper-slide:first-child .product-swatch-item:nth-child(1)"
      ).each(function () {
        this.style.setProperty("display", "none", "important");
      });
      // .product-swatch-carousel-lens .swiper-wrapper .swiper-slide:first-child .product-swatch-item:nth-child(3)
    } else {
      jQuery(".product-swatch-carousel-lens .swiper-pagination").show();
      jQuery(".product-swatch-carousel-lens  .swiper-button-next").each(
        function () {
          this.style.setProperty("display", "block", "important");
        }
      );
      jQuery(".product-swatch-carousel-lens  .swiper-button-prev").each(
        function () {
          this.style.setProperty("display", "block", "important");
        }
      );
      jQuery(
        ".product-swatch-carousel-lens .swiper-wrapper .swiper-slide:first-child .product-swatch-item:nth-child(2), .product-swatch-carousel-lens .swiper-wrapper .swiper-slide:first-child .product-swatch-item:nth-child(1)"
      ).each(function () {
        this.style.setProperty("display", "block", "important");
      });
    }
  }
});

var product_swatch_carousel_lens = new Swiper(".product-swatch-carousel-lens", {
  loop: false,
  rewind: true,
  spaceBetween: 0,
  slidesPerView: 1,
  preventClicks: false,
  preventClicksPropagation: false,
  speed: 600,
  threshold: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  a11y: {
    enabled: false,
  },
  on: {
    // LazyLoad swiper images after swiper initialization
    afterInit: (swiper) => {
      new LazyLoad({
        container: swiper.el,
        cancel_on_exit: false,
      });
    },
  },
  on: {
    setTransition: function () {},
    init: function () {},
  },
});

window.product_swatch_carousel_lens = product_swatch_carousel_lens;

var urlParams = new URLSearchParams(window.location.search);
const collectionID = urlParams.get("collection");
const clickID = urlParams.get("jump");
let currentFlag = false;
//console.log(collectionID);
if (collectionID !== null) {
  product_swatch_carousel_lens.slideTo(collectionID);
}

const shieldsflag = urlParams.get("shield");
if (shieldsflag !== null) {
  console.log("clickeddd");
  document.querySelector(".add-on-product-checkbox").click();
}

product_swatch_carousel_lens.on("slideChangeTransitionEnd", function () {
  // Setting the query parameters
  //var shieldstring = "&shield=true";
  var shieldstring = "";
  var querystring = "?collection=" + product_swatch_carousel_lens.realIndex;
  if (product_swatch_carousel_lens.realIndex == 4) {
    querystring = "?collection=0";
  }
  if (window.shieldsInStock) {
    if (document.querySelector(".add-on-product-checkbox").checked) {
      querystring = querystring + shieldstring;
      console.log(querystring);
    }
  }

  $(".product-top-list-swiper a").each(function () {
    var href = $(this).attr("href").split("?")[0];
    if (href) {
      $(this).attr("href", href + querystring);
    }
  });

  //console.log(clickID);
  //console.log(currentFlag);
  // Selecting first variant
  if (clickID == "false" && currentFlag == false) {
    //console.log("hey");
    currentFlag = true;
  } else {
    //console.log("hi");
    if (product_swatch_carousel_lens.realIndex != 3) {
      jQuery(
        ".product-swatch-carousel-lens .swiper-slide-active .product-swatch-item:first-child label"
      ).click();
      // console.log("hereeee");
    }
  }

  if (window.specialEditionLens != "") {
    if (product_swatch_carousel_lens.realIndex == 4) {
      isOnSpecial = true;
      console.log(
        jQuery(
          ".product-swatch-carousel-lens .swiper-slide-active .product-swatch-item:first-child label"
        ).data("frame")
      );
      console.log("lens on special");
      speicalChanging = false;
      let flag = false;
      $(".product-swatch-carousel-frame .swiper-slide").each(function (
        index,
        element
      ) {
        if ($(this).find("label").data("frame") == "frost" && flag == false) {
          // console.log("found");
          // console.log (index);
          //console.log("here2");
          if (specialChanging != true) {
            console.log("here3");
            product_swatch_carousel_frame.slideTo(index);
          }
          specialChanging = false;
          flag = true;
          // if (index > 2 && index < 6) {
          //   product_swatch_carousel_frame.slideTo(index)
          // }
        }
      });
    } else {
      if (isOnSpecial == true) {
        console.log("here4");
        //console.log("onSpecial");
        product_swatch_carousel_frame.slideTo(
          product_swatch_carousel_frame.activeIndex - 1
        );
        isOnSpecial = false;

        // potentially wrong
        specialChanging = false;
      }
    }
  }
  if (product_swatch_carousel_lens.realIndex == 4) {
    console.log("swatch");
    jQuery(".product-swatch-carousel-lens .swiper-pagination").hide();
    jQuery(".product-swatch-carousel-lens  .swiper-button-next").each(
      function () {
        this.style.setProperty("display", "none", "important");
      }
    );
    jQuery(".product-swatch-carousel-lens  .swiper-button-prev").each(
      function () {
        this.style.setProperty("display", "none", "important");
      }
    );

    // Hiding the XL button and clicking
    //jQuery('variant-radios fieldset:nth-child(3) .product-swatch-item:last-child').addClass("strike-xl")
    //jQuery('variant-radios fieldset:nth-child(3) .product-swatch-item:first-child label').click();
    //jQuery('.rad-letter').css("display","block");
    // jQuery('.radavist-btn').css("display","block");
    // jQuery(".btn.klaviyo-bis-trigger").hide();
    // console.log("adds hide");
    // jQuery('.add-btns button').hide();
  } else {
    if (product_swatch_carousel_frame.realIndex != 4) {
      jQuery(".product-swatch-carousel-lens .swiper-pagination").show();
      jQuery(".product-swatch-carousel-lens  .swiper-button-next").each(
        function () {
          this.style.setProperty("display", "block", "important");
        }
      );
      jQuery(".product-swatch-carousel-lens  .swiper-button-prev").each(
        function () {
          this.style.setProperty("display", "block", "important");
        }
      );

      // Showing the XL button
      //jQuery('variant-radios fieldset:nth-child(3) .product-swatch-item:last-child').removeClass("strike-xl");
      //jQuery('.rad-letter').css("display","none");
      jQuery(".radavist-btn").css("display", "none");
      jQuery(".add-btns button").show();
    }
  }

  let rxBtn = document.querySelector("#rxbtn.rx-btn");
  let rxBuy = document.querySelector('#rxshopbtn');
  let rxIndex = 3;
  let isCammina = window.location.pathname.includes("cammina");

  if (isCammina) {
    rxIndex = 2;
  }

  if (+product_swatch_carousel_lens.realIndex === rxIndex) {
    rxBtn.style.display = "block";
    jQuery(".product__info-wrapper").addClass("rx");
    jQuery(".product__info-wrapper").removeClass("regular");

    if (isCammina) {
      rxBtn.innerText = 'Coming Soon';
      rxBtn.disabled = true;
      rxBtn.style.cursor = 'not-allowed';
      rxBuy.innerText = 'Coming Soon';
      rxBuy.disabled = true;
      rxBuy.style.cursor = 'not-allowed';
    } else {
      rxBtn.innerText = 'ORDER RX OMBRAZ';
      rxBtn.disabled = false;
      rxBtn.style.cursor = 'pointer';
      rxBuy.innerText = 'ORDER RX OMBRAZ';
      rxBuy.disabled = false;
      rsBuy.style.cursor = 'pointer';
    }
    // jQuery('.add-btns').hide();
    // jQuery('.btn.klaviyo-bis-trigger').hide();
    // jQuery('.rx-heading').show();
    // jQuery('.rx-btn').show();
    // jQuery('.rx-price').show();
    // jQuery('.non-rx-price').hide();
    // jQuery('#showshields').hide();
    // jQuery('.rx-description').show();
    // jQuery('.slr-stars-score').hide();
    // jQuery('.regular-description').hide();
    // jQuery('.shop-rx-link').hide();
    // console.log('3');
  } else {
    rxBtn.style.display = "none";
    jQuery(".product__info-wrapper").removeClass("rx");
    jQuery(".product__info-wrapper").addClass("regular");
    // jQuery('.add-btns').show();
    // // jQuery(".btn.klaviyo-bis-trigger").show();
    // jQuery('.rx-btn').hide();
    // jQuery('.rx-price').hide();
    // jQuery('.non-rx-price').show();
    // jQuery('.regular-description').show();
    // jQuery('#showshields').show();
    // jQuery('.rx-heading').hide();
    // jQuery('.rx-description').hide();
    // jQuery('.slr-stars-score').show();
    // jQuery('.shop-rx-link').show();
  }
});

$(".product-swatch-carousel-lens .swiper-slide").each(function (
  index,
  element
) {
  var input_list = $(this).find("input");
  var has_checked = false;
  for (var i = 0; i < input_list.length; i++) {
    if ($(input_list[i]).attr("checked") == "checked") {
      has_checked = true;
      break;
    }
  }

  if (has_checked) {
    //console.log (index);
    if (index > 0 && index < 5) {
      product_swatch_carousel_lens.slideTo(index);
    }
  }
});

var product_lens_comparison_swiper_top = new Swiper(".lens-cmp-swiper-top", {
  autoHeight: true,
  loop: false,
  //   loopedSlides: 3,
  spaceBetween: 0,
  slidesPerView: 3,
  //   centeredSlides: true,
  slideToClickedSlide: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      loop: false,
      rewind: true,
      threshold: 30,
    },
    480: {
      slidesPerView: 1,
      loop: false,
      rewind: true,
      threshold: 30,
    },
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 3,
    },
  },
  on: {
    // LazyLoad swiper images after swiper initialization
    afterInit: (swiper) => {
      new LazyLoad({
        container: swiper.el,
        cancel_on_exit: false,
      });
    },
  },
});

var product_lens_comparison_swiper_bottom = new Swiper(
  ".lens-cmp-swiper-bottom",
  {
    lazy: false,
    loop: false,
    allowTouchMove: false,
    spaceBetween: 0,
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    speed: 0,
    thumbs: {
      swiper: product_lens_comparison_swiper_top,
    },
    breakpoints: {
      320: {
        loop: false,
        rewind: true,
        speed: 0,
      },
      480: {
        loop: false,
        rewind: true,
        speed: 0,
      },
      768: {},
      1024: {},
    },
    on: {
      // LazyLoad swiper images after swiper initialization
      afterInit: (swiper) => {
        new LazyLoad({
          container: swiper.el,
          cancel_on_exit: false,
        });
      },
    },
  }
);

// product_lens_comparison_swiper_top.controller.control = product_lens_comparison_swiper_bottom;
// product_lens_comparison_swiper_bottom.controller.control = product_lens_comparison_swiper_top;

// Active thumb sync with main slide
product_lens_comparison_swiper_top.on("slideChange", function () {
  var activeIndex = product_lens_comparison_swiper_top.activeIndex;
  var bottomPagination = $(".lens-cmp-swiper-bottom .swiper-pagination-bullet")[
    activeIndex
  ];

  //console.log (activeIndex, $(bottomPagination).attr('aria-label'));
  $(bottomPagination).trigger("click");
});

var icons_carsousel_swiper_top = new Swiper(".icons-carousel-swiper-top", {
  loop: false,
  spaceBetween: 10,
  slidesPerView: 4,
  breakpoints: {
    320: {
      spaceBetween: 20,
    },
    480: {
      spaceBetween: 20,
    },
  },
  on: {
    // LazyLoad swiper images after swiper initialization
    afterInit: (swiper) => {
      new LazyLoad({
        container: swiper.el,
        cancel_on_exit: false,
      });
    },
  },
});

var icons_carsousel_swiper_bottom = new Swiper(
  ".icons-carousel-swiper-bottom",
  {
    lazy: false,
    loop: true,
    spaceBetween: 0,
    autoHeight: true,
    threshold: 30,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    thumbs: {
      swiper: icons_carsousel_swiper_top,
    },
    on: {
      // LazyLoad swiper images after swiper initialization
      afterInit: (swiper) => {
        new LazyLoad({
          container: swiper.el,
          cancel_on_exit: false,
        });
      },
    },
  }
);

/////////////////// Swiper Slide ////////////////////

/*var product_list_swiper = new Swiper(".product-top-list-swiper", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  loop: true,
  centeredSlides: true,
  slidesPerView: "auto",
  slidesPerView: 5,
  spaceBetween: 10,
  breakpoints: {
    320: {
      slidesPerView: 1,
      loop: true,
    },
    480: {
      slidesPerView: 3,
      loop: true,
    },
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 5,
    },
  },
  on: {
    afterInit: function () {
    }
  }
});*/

/////////////////// Slick Slide ////////////////////
/*var product_list_swiper = $('.product-top-list-swiper');

product_list_swiper.slick({
  centerMode: true,
  centerPadding: '100px',
  slidesToShow: 3,
  arrows: true,
  variableWidth: true,
  swipeToSlide: true,
//   infinite: false,
  prevArrow:"<button type='button' aria-label='Previous' class='slick-prev slick-arrow'><i class='arrow left' aria-hidden='true'></i></button>",
  nextArrow:"<button type='button' aria-label='Next' class='slick-next slick-arrow'><i class='arrow right' aria-hidden='true'></i></button>"
});*/

if (!product_thumbnail_swiper) {
  product_thumbnail_swiper = new Swiper(".product-thumbnail-swiper", {
    spaceBetween: 10,
    slidesPerView: 6,
    slideToClickedSlide: true,
    threshold: 20,
    observer: true,
    observeParents: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,

    navigation: {
      nextEl: ".swiper-button-next-main-product-thumb",
      prevEl: ".swiper-button-prev-main-product-thumb",
    },
    breakpoints: {
      320: {
        slidesPerView: 5,
        spaceBetween: 5,
      },
      480: {
        slidesPerView: 5,
        spaceBetween: 5,
      },
      768: {
        slidesPerView: 5,
        spaceBetween: 5,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 10,
      },
    },
    on: {
      // LazyLoad swiper images after swiper initialization
      afterInit: (swiper) => {
        new LazyLoad({
          container: swiper.el,
          cancel_on_exit: false,
        });
      },
    },
  });
}

if (!product_swiper) {
  product_swiper = new Swiper(".product-swiper", {
    zoom: {
      maxRatio: 2,
      toggle: true,
    },
    lazy: false,
    threshold: 20,

    observer: true,
    observeParents: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,

    spaceBetween: 10,
    autoHeight: true,
    navigation: {
      nextEl: ".swiper-button-next-main-product-thumb",
      prevEl: ".swiper-button-prev-main-product-thumb",
    },
    thumbs: {
      swiper: product_thumbnail_swiper,
      //       autoScrollOffset: 1,
    },
    on: {
      // LazyLoad swiper images after swiper initialization
      afterInit: (swiper) => {
        new LazyLoad({
          container: swiper.el,
          cancel_on_exit: false,
        });
      },
    },
  });

  //if (product_swiper) product_swiper.update();
}

product_swiper.on("slideChange", () => {
  console.log("thumb active -> ", product_swiper.activeIndex);
  //   product_thumbnail_swiper.slideTo(product_swiper.activeIndex);
  //   const stopVideos = () => {
  //     jQuery("iframe").attr("allow","");
  //     document.querySelectorAll('iframe').forEach(v => {
  //     	v.src = v.src
  //     });
  //   };
  // stopVideos();
});

// swiper.on('touchEnd', function (s, e) {
//   if(e.touches.length > 0) {
//     swiper.zoom.out();
//   }
// });

/***************************  Product Lens Comparison ***************************/

function getOriginWidth(str) {
  var windowsize = $(window).width();

  $(window).resize(function () {
    var windowsize = $(window).width();
  });

  var color_img = $(str + " img");
  var theImage = new Image();
  theImage.src = color_img.attr("src");

  theImage.onload = function () {
    var color_w = Math.min(theImage.width, windowsize);
    color_w -= 30; //for padding

    $(str).css({ width: color_w, margin: "auto" });
    $(str + " img").css({ width: color_w, "max-width": color_w });
  };
}

$(document).ready(function () {
  // 	get origin color_image width
  //   getOriginWidth('#color0');
  //   getOriginWidth('#color1');
  //   getOriginWidth('#color2');

  $(".ba-slider").each(function () {
    var cur = $(this);
    // Adjust the slider
    var width = cur.width() + "px";
    cur.find(".resize img").css("width", width);
    // Bind dragging events
    drags(cur.find(".handle"), cur.find(".resize"), cur);
  });
});

// Update sliders on resize.
$(window).resize(function () {
  $(".ba-slider").each(function () {
    var cur = $(this);

    var width = cur.width() + "px";
    cur.find(".resize img").css("width", width);
  });
});

function drags(dragElement, resizeElement, container) {
  // Initialize the dragging event on mousedown.
  dragElement
    .on("mousedown touchstart", function (e) {
      dragElement.addClass("draggable1");
      resizeElement.addClass("resizable");

      // Check if it's a mouse or touch event and pass along the correct value
      var startX = e.pageX ? e.pageX : e.originalEvent.touches[0].pageX;

      // Get the initial position
      var dragWidth = dragElement.outerWidth(),
        posX = dragElement.offset().left + dragWidth - startX,
        containerOffset = container.offset().left,
        containerWidth = container.outerWidth();

      // Set limits
      minLeft = containerOffset + 10;
      maxLeft = containerOffset + containerWidth - dragWidth - 10;

      // Calculate the dragging distance on mousemove.
      dragElement
        .parents()
        .on("mousemove touchmove", function (e) {
          // Check if it's a mouse or touch event and pass along the correct value
          var moveX = e.pageX ? e.pageX : e.originalEvent.touches[0].pageX;

          leftValue = moveX + posX - dragWidth;

          // Prevent going off limits
          if (leftValue < minLeft) {
            leftValue = minLeft;
          } else if (leftValue > maxLeft) {
            leftValue = maxLeft;
          }

          // Translate the handle's left value to masked divs width.
          widthValue =
            ((leftValue + dragWidth / 2 - containerOffset) * 100) /
              containerWidth +
            "%";

          // Set the new values for the slider and the handle.
          // Bind mouseup events to stop dragging.
          $(".draggable1")
            .css("left", widthValue)
            .on("mouseup touchend touchcancel", function () {
              $(this).removeClass("draggable1");
              resizeElement.removeClass("resizable");
            });
          $(".resizable").css("width", widthValue);
        })
        .on("mouseup touchend touchcancel", function () {
          dragElement.removeClass("draggable1");
          resizeElement.removeClass("resizable");
        });
      e.preventDefault();
    })
    .on("mouseup touchend touchcancel", function (e) {
      dragElement.removeClass("draggable1");
      resizeElement.removeClass("resizable");
    });
}

/*************************  Product Lens Comparison end  ************************/

$(document).ready(function () {
  var youtube = document.querySelectorAll(".youtube");
  var isClicked = [];

  for (var i = 0; i < youtube.length; i++) {
    if (isClicked[i] != true) {
      // console.log("hiiii");
      //var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/sddefault.jpg";
      var source =
        "https://i.ytimg.com/vi_webp/" +
        youtube[i].dataset.embed +
        "/maxresdefault.webp";

      var image = new Image();
      image.src = source;
      image.setAttribute("alt", youtube[i].dataset.alt);
      image.setAttribute("loading", "lazy");
      image.addEventListener(
        "load",
        (function () {
          youtube[i].appendChild(image);
        })(i)
      );

      youtube[i].addEventListener("click", function () {
        isClicked[i] = true;
        console.log("clickeddd");

        var iframe = document.createElement("iframe");

        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "");
        iframe.setAttribute("width", "838");
        iframe.setAttribute("height", "478");
        iframe.setAttribute("loading", "lazy");
        iframe.setAttribute("allow", "autoplay");
        iframe.setAttribute(
          "src",
          "https://www.youtube.com/embed/" +
            this.dataset.embed +
            "?rel=0&showinfo=0&vq=720&autoplay=1"
        );

        this.innerHTML = "";
        this.appendChild(iframe);
      });
    }
  }

  $(".product-lens-compare input").change(function () {
    $(".lens-cmp-swiper-bottom .swiper-wrapper")
      .find(".swiper-slide")
      .removeClass("swiper-slide");
    var place_type = $(
      ".product-lens-compare input[type='radio']:checked"
    ).val();
    if (place_type == "mountain") {
      $(".lens-cmp-swiper-bottom .swiper-wrapper")
        .find(".mountain")
        .removeClass("non-swiper-slide");

      $(".lens-cmp-swiper-bottom .swiper-wrapper")
        .find(".desert")
        .addClass("non-swiper-slide");
      $(".lens-cmp-swiper-bottom .swiper-wrapper")
        .find(".marine")
        .addClass("non-swiper-slide");
      $(".lens-cmp-swiper-bottom .swiper-wrapper")
        .find(".mountain")
        .addClass("swiper-slide");
    } else if (place_type == "desert") {
      $(".lens-cmp-swiper-bottom .swiper-wrapper")
        .find(".desert")
        .removeClass("non-swiper-slide");

      $(".lens-cmp-swiper-bottom .swiper-wrapper")
        .find(".mountain")
        .addClass("non-swiper-slide");
      $(".lens-cmp-swiper-bottom .swiper-wrapper")
        .find(".marine")
        .addClass("non-swiper-slide");
      $(".lens-cmp-swiper-bottom .swiper-wrapper")
        .find(".desert")
        .addClass("swiper-slide");
    } else {
      $(".lens-cmp-swiper-bottom .swiper-wrapper")
        .find(".marine")
        .removeClass("non-swiper-slide");

      $(".lens-cmp-swiper-bottom .swiper-wrapper")
        .find(".desert")
        .addClass("non-swiper-slide");
      $(".lens-cmp-swiper-bottom .swiper-wrapper")
        .find(".mountain")
        .addClass("non-swiper-slide");
      $(".lens-cmp-swiper-bottom .swiper-wrapper")
        .find(".marine")
        .addClass("swiper-slide");
    }

    $("." + place_type + " .ba-slider").each(function () {
      var cur = $(this);
      // Adjust the slider
      var width = cur.width() + "px";
      cur.find(".resize img").css("width", width);
      // Bind dragging events
      drags(cur.find(".handle"), cur.find(".resize"), cur);
    });
    //$('.lens-cmp-swiper-bottom')[0].swiper.update();
  });

  /*if( typeof product_variants_removed != undefined ) {  // was there items to be removed?
    var $addToCartForm = $('form[action="/cart/add"]');
    if (window.MutationObserver) {// && $addToCartForm.length) {
    var config = { childList: true, subtree: true };
        product_variants_removed.forEach(function(item){
          console.log (item);
          $('.product-swatch-carousel input').filter(function() { return $(this).text() === item; }).prop('disabled', true);
        });    
    }
  }*/
});

$(window).bind("load", function () {
  // $("#page-loader").remove();
  var coll = $(".guide-expander");

  for (var i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function () {
      this.classList.toggle("active");

      var content = this.nextElementSibling;

      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + 100 + "px";
      }
    });
  }
});
// if (jQuery(window).width() > 989) {
//     product_swiper.removeSlide(2);
//   product_thumbnail_swiper.removeSlide(2);
// }

if (product_swatch_carousel_frame.realIndex == 4) {
  console.log("bottommm");
  jQuery(".product-swatch-carousel-lens .swiper-pagination").hide();
  jQuery(".product-swatch-carousel-lens  .swiper-button-next").each(
    function () {
      this.style.setProperty("display", "none", "important");
    }
  );
  jQuery(".product-swatch-carousel-lens  .swiper-button-prev").each(
    function () {
      this.style.setProperty("display", "none", "important");
    }
  );
  jQuery(".product-swatch-carousel-lens  .swiper-button-prev").each(
    function () {
      this.style.setProperty("display", "none", "important");
    }
  );
  jQuery(
    ".product-swatch-carousel-lens .swiper-wrapper .swiper-slide:first-child .product-swatch-item:nth-child(2), .product-swatch-carousel-lens .swiper-wrapper .swiper-slide:first-child .product-swatch-item:nth-child(1)"
  ).each(function () {
    this.style.setProperty("display", "none", "important");
  });
}
